import { getDatabase } from 'database';
import { User } from 'types/user';

export async function getUser(usernameOrBarcode: string): Promise<User> {
  const db = await getDatabase();
  let user = await db.read(db.config.indexes.User, usernameOrBarcode) as User;
  return user;
}

export async function saveUser(user: User) {
  await addOrUpdate(user.username, user);

  if (user.barcode !== '' && user.barcode !== null) {
    await addOrUpdate(user.barcode, user);
  }
}

async function addOrUpdate(key: string, encodedUser: User) {
  const db = await getDatabase();
  if (!await getUser(key)) {
    await db.add(db.config.indexes.User, encodedUser, key);
  } else {
    await db.put(db.config.indexes.User, encodedUser, key);
  }
}


// WEBPACK FOOTER //
// ./src/services/user-service.ts